import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { FileUploader } from "ng2-file-upload";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { Loggerservice } from "../../../services/logger-service";
import { Router } from "@angular/router";
import { CommonService } from "../../../services/common.service";

const URL = window["omsubconfig"].backOffice + "/images/upload";

@Component({
  selector: "app-bannermaster",
  templateUrl: "./bannermaster.component.html"
})
export class BannermasterComponent implements OnInit {
  datePickerConfig: Partial<BsDatepickerConfig>;
  rejected = 0;
  searchlist: boolean = true;
  showList: boolean = false;
  nameExist: boolean = false;
  previousData: any = [];
  offSubmit = false;
  minRemark = false;

  aprvbtn = false;
  approveStatus;
  isApproved = false;
  updateApprove = false;
  searchresult: boolean = false;

  bannerCodeMinLength = false;
  bannerCodeExceedLength = false;
  bannerCodeNotAlphaNumeric: boolean = false;
  viewTitle: string = "Banner View";
  insertDataTitle: string = "Data Successfully Inserted";
  loader: any = false;
  checkGuest: boolean = false;
  checkMember: boolean = false;
  checkBoth: boolean = false;

  screentitle: string = "Banner Master";
  actionmode: string = "Seacrh";
  parent_table = "mst_banner";
  parent_table_ID = "BANNER_ID";
  BANNER_TYPE = "BANNER_CODE";
  BANNER_PAGE = "BANNER_PAGE";
  PAGE_SECTION = "PAGE_SECTION";
  // BANNER_CODE = "BANNER_CODE";
  BANNER_IMAGE = "BANNER_IMAGE";
  BANNER_TEXT = "BANNER_TEXT";
  LOGIN_BANNER_IMAGE = "LOGIN_BANNER_IMAGE";
  LOGIN_BANNER_TEXT = "LOGIN_BANNER_TEXT";
  PLATFORM = "PLATFORM";
  // APPLICABLE_FROM = "APPLICABLE_FROM";
  // APPLICABLE_TO = "APPLICABLE_TO";
  // IS_LOGIN = "IS_LOGIN";

  Parent_result_ID = "";
  APPROVAL_STATUS = "APPROVAL_STATUS";
  dbFields = [
    this.BANNER_PAGE,
    this.PAGE_SECTION,
    // this.BANNER_CODE,
    this.BANNER_IMAGE,
    this.BANNER_TEXT,
    this.LOGIN_BANNER_IMAGE,
    this.LOGIN_BANNER_TEXT,
    this.BANNER_TYPE,
    this.PLATFORM,
    "BANNER_HEADER"

    // this.APPLICABLE_FROM,
    // this.APPLICABLE_TO
    // this.IS_LOGIN
  ];
  dbFieldss = [
    this.BANNER_PAGE,
    this.PAGE_SECTION,
    // this.BANNER_CODE,
    this.BANNER_IMAGE,
    this.BANNER_TEXT,
    this.LOGIN_BANNER_IMAGE,
    this.LOGIN_BANNER_TEXT,
    this.BANNER_TYPE,
    this.PLATFORM,
    // this.APPLICABLE_FROM,
    // this.APPLICABLE_TO,
    // this.IS_LOGIN,
    "STATUS",
    "BANNER_HEADER"
  ];

  bannerType: any = [
    { key: "R", value: "Reedem" },
    { key: "A", value: "Accrual" }
  ];
  bannerPages: any = [
    "Home Page",
    "Review Page",
    "Transition Page",
    "Manage Booking" ,
    "SRP Page",
    "Booking Confirmation Page",
    "Voucher Pdf"
  ];
  pageSections: any = [
    // "Search Widget",
    // "Texts",
    // "Top Left",
    // "Top Right",
    // "Bottom Left",
    // "Bottom Center",
    // "Review Top Left",
    // "Review Top Right",
    // "Transition Top Left",
    // "Transition Top Right",
    // "ManageBooking Top Left",
    // "ManageBooking Top Right",
    // "Test",
    // "SRP MIDDLE",
    // "SRP Domastic Oneway",
    // "SRP Domastic Return",
    // "SRP International Oneway",
    // "SRP International Return"
  ];
  searchitem = " ";
  searchColumn = " ";
  childtables = [];
  filters = [];
  screen_details: any = [];
  search_details: any = [];
  serachtabledata: any = [];
  serachTableInfo: any = [];
  data: any = [];
  status: any = {};
  sortType = "";
  p: number = 1;

  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  BANNER_IMG = "";
  LOGIN_BANNER_IMG = "";
  isBannerImage: boolean = false;
  isSearchWidget: boolean = false;
  editedData: any = "";
  editedData1: any = "";
  logineditedData: any = "";
  bannerHeading: any = "";
  isLoginData: boolean = false;
  isNotLoginData: boolean = false;
  // count1 = 0;
  // count2 = 0;
  constructor(
    private vernostService: VernostServiceService,
    private logService: Loggerservice,
    private commonService : CommonService,
    private router: Router
  ) {}

  public uploader: FileUploader = new FileUploader({
    url: URL,
    itemAlias: "photo"
  });
  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    this.isBannerImage = true;
    this.isSearchWidget = false;
    var rollArrayBannerMaster = {
      funId: this.fid,
      roleID: this.roleID
    };

    this.vernostService.checkFunAccess(rollArrayBannerMaster).subscribe(resp => {
      this.RAC_VIEW = JSON.stringify(resp[0].addinfo[0].RAC_VIEW);
      this.RAC_ADD = JSON.stringify(resp[0].addinfo[0].RAC_ADD);
      this.RAC_EDIT = JSON.stringify(resp[0].addinfo[0].RAC_EDIT);
      this.RAC_APROVE = JSON.stringify(resp[0].addinfo[0].RAC_APROVE);
    });
    this.Parent_result_ID = "";
    this.screen_details = {
      BANNER_PAGE: "",
      PAGE_SECTION: "",
      // BANNER_CODE: "",
      BANNER_IMAGE: "",
      BANNER_TEXT: "",
      LOGIN_BANNER_IMAGE: "",
      LOGIN_BANNER_TEXT: "",
      BANNER_TYPE: "",
      PLATFORM: "",
      // APPLICABLE_FROM: "",
      // APPLICABLE_TO: "",
      // IS_LOGIN: "",
      APPROVAL_REMARKS: ""
    };
    this.search_details = {
      BANNER_PAGE: "",
      PAGE_SECTION: "",
      // BANNER_CODE: "",
      BANNER_IMAGE: "",
      BANNER_TEXT: "",
      LOGIN_BANNER_IMAGE: "",
      LOGIN_BANNER_TEXT: "",
      BANNER_TYPE: ""
      // APPLICABLE_FROM: "",
      // APPLICABLE_TO: "",
      // IS_LOGIN: ""
    };
    this.showList = false;
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {

      var property = JSON.parse(response);

      if (this.isNotLoginData == true) {
        this.screen_details.BANNER_IMAGE = property.fileName;
        this.BANNER_IMG = property.fileName;
      }
      if (this.isLoginData == true) {
        this.screen_details.LOGIN_BANNER_IMAGE = property.fileName;
        this.LOGIN_BANNER_IMG = property.fileName;
      }
    };
    this.getBannerNames();
  }
  getBannerNames(){
    this.vernostService.getBannerNames().subscribe(response => {
      this.pageSections = Object.values(response);
    }); 
  }

  getFileDetails(event, type) {
    for (var i = 0; i < event.target.files.length; i++) {
      if (type == "login") {
        this.isLoginData = true;
      } else {
        this.isLoginData = false;
      }
      if (type == "not-login") {
        this.isNotLoginData = true;
      } else {
        this.isNotLoginData = false;
      }
      this.uploader.uploadAll();
    }
  }

  checkAproval() {
    var dbField = [this.APPROVAL_STATUS];
    let arrayBannerMaster = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayBannerMaster).subscribe(response => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }

  changeName() {
    // alert(this.Parent_result_ID);
    let dataBannerMaster = {
      parent_table: this.parent_table,
      formData: this.Parent_result_ID,
      columnName: "BANNER_ID"
    };

    this.vernostService.getSTATUS(dataBannerMaster).subscribe(res => {
      this.approveStatus = res[0].status;
      if (this.isApproved && this.actionmode == "Edit") {
        this.checkColor();
      }
    });
  }

  gotochangestatus(id) {
    this.nameExist = false;
    if (this.actionmode == "Edit") {
      var data = {
        parent_table: this.parent_table,
        formData: this.Parent_result_ID,
        columnName: this.parent_table_ID
      };

      this.vernostService.editstatus(data).subscribe(response => {
        //   alert(response);
        this.isApproved = false;
      });
    }
    if (id == 2) {
      if (this.screen_details.PAGE_SECTION == "Texts") {
        this.isBannerImage = false;
      } else {
        this.isBannerImage = true;
      }
      if (this.screen_details.PAGE_SECTION == "Search Widget") {
        this.isSearchWidget = true;
      } else {
        this.isSearchWidget = false;
      }
    }
  }

/**
 * No Reference Found for this code. Pls re-check before deleting - Gaurav
 */

  /*changeBtnColor(id, status) {
    if (status == 1) {
      status = 0;
    } else if (status == 0) {
      status = 1;
    }

    let dataBannerMaster = {
      parent_table: this.parent_table,
      formData: id,
      columnName: "BANNER_ID",
      status: status
    };

    this.vernostService.changeSTATUS(dataBannerMaster).subscribe(response => {
      this.searchData();
    });
  }*/

  checkColor() {
    let approveStatus = this.approveStatus;
    this.commonService.checkColor(approveStatus,'banner-master');
  }

  aproveReject(status) {
    this.isApproved = true;
    var currentTime = new Date();

    var dbFieldBannerMaster = [
      this.APPROVAL_STATUS,
      this.APPROVAL_REMARKS,
      this.APPROVAL_BY,
      "STATUS",
      "APPROVAL_DATE_TIME"
    ];
    if (status == 1) {
      this.approveStatus = 1;
    }
    var formDataBannerMaster = [
      status,
      this.aprove_details.APPROVAL_REMARKS,
      this.uid,
      status,
      currentTime
    ];
    var array = {
      dbField: dbFieldBannerMaster,
      parent_table: this.parent_table,
      formData: formDataBannerMaster,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };

    this.vernostService.aproveReject(array).subscribe(response => {
      this.aprove_details.APPROVAL_REMARKS = "";
      if (status == 2) {
        //    this.searchForm();
        //  this.searchData();

        this.logService.create_log_masters(
          "'Component Name':Banner Master,'Action':Reject Record,'Modified by':" +
            localStorage.getItem("fname") +
            "'Record':" +
            JSON.stringify(this.screen_details),
          "info"
        );
        this.rejected = 2;
      } else {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }

        if (response[0].aproval == "aproved") {
          this.aprvbtn = false;
          this.logService.create_log_masters(
            "'Component Name':Banner Master,'Action':Approve Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Record':" +
              JSON.stringify(this.screen_details),
            "info"
          );
        }
        this.aprvbtn = false;
      }
    });
    if (this.actionmode == "Edit") {
      this.submitdata();
    }
    this.searchData();
  }
  setId(id) {
    this.Parent_result_ID = id;
  }

  checkEdit() {
    if (this.actionmode == "Edit") {
      this.isApproved = false;
      this.updateApprove = true;
      this.RAC_APROVE = "1";
    }
  }

 /*
  sortByOrder(data, number_banner) {
    if (number_banner == 1) {
      if (this.count1 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count1++;
      this.count2 = 0;
    }
    if (number_banner == 2) {
      if (this.count2 % 2 == 0) {
        this.sortType = "ASC";
      } else {
        this.sortType = "DESC";
      }
      this.count2++;
      this.count1 = 0;
    }
    var arrayBannerMaster = {
      sortField: data,
      parent_table: this.parent_table,
      childtables: this.childtables,
      filters: this.filters,
      sortType: this.sortType,
      dbFields: this.searchColumn,
      searchData: this.searchitem
    };
    this.vernostService.sortByOrder(arrayBannerMaster).subscribe(res => {
      this.serachtabledata = res;
    });
  } */

  addForm() {
    this.rejected = 0;
    document.getElementById("errs").innerHTML = "";
    this.nameExist = false;
    this.search_details = {
      BANNER_PAGE: "",
      PAGE_SECTION: "",
      // BANNER_CODE: "",
      BANNER_IMAGE: "",
      BANNER_TEXT: "",
      BANNER_TYPE: "",
      PLATFORM: ""
      // APPLICABLE_FROM: "",
      // APPLICABLE_TO: ""
      // IS_LOGIN: ""
    };
    this.bannerCodeMinLength = false;
    this.bannerCodeExceedLength = false;
    this.bannerCodeNotAlphaNumeric = false;
    this.BANNER_IMG = "";
    this.LOGIN_BANNER_IMG = "";
    this.Parent_result_ID = "";
    this.showList = false;
    this.nameExist = false;

    this.actionmode = "Add";
  }
  searchForm() {
    this.rejected = 0;
    this.editedData = "";
    this.logineditedData = "";
    document.getElementById("errs").innerHTML = "";
    this.nameExist = false;
    this.screen_details = {
      BANNER_PAGE: "",
      PAGE_SECTION: "",
      // BANNER_CODE: "",
      BANNER_IMAGE: "",
      BANNER_TEXT: "",
      LOGIN_BANNER_IMAGE: "",
      LOGIN_BANNER_TEXT: "",
      BANNER_TYPE: "",
      PLATFORM: "",
      // APPLICABLE_FROM: "",
      // APPLICABLE_TO: "",
      // IS_LOGIN: ""
    };
    this.bannerCodeMinLength = false;
    this.bannerCodeExceedLength = false;
    this.bannerCodeNotAlphaNumeric = false;
    this.actionmode = "Search";
    //this.searchData();
  }

  showFormData(formData, toggle, status, approvestatus) {
    if (toggle == "2") {
      this.updateApprove = true;
      this.showList = false;
      this.actionmode = "Edit";
      if (status == 0 && approvestatus == 0) {
        this.isApproved = false;
      }
      if (approvestatus == 1) {
        //alert("already approved");
        this.isApproved = true;
      }
    }

    this.Parent_result_ID = formData;
    let arrayBannerMaster = {
      parent_table: this.parent_table,
      dbFields: this.dbFieldss,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    this.vernostService.getData(arrayBannerMaster).subscribe(response => {
      
      if (
        response[0].result[0].BANNER_IMAGE == undefined ||
        response[0].result[0].BANNER_IMAGE == null
      ) {
        this.BANNER_IMG = "";
      } else {
        this.BANNER_IMG = response[0].result[0].BANNER_IMAGE;
      }
      if (
        response[0].result[0].LOGIN_BANNER_IMAGE == undefined ||
        response[0].result[0].LOGIN_BANNER_IMAGE == null
      ) {
        this.LOGIN_BANNER_IMG = "";
      } else {
        this.LOGIN_BANNER_IMG = response[0].result[0].LOGIN_BANNER_IMAGE;
      }

      if (response[0].result[0].PAGE_SECTION == "Texts") {
        this.isBannerImage = false;
      } else {
        this.isBannerImage = true;
      }

      if (response[0].result[0].PAGE_SECTION == "Search Widget") {
        this.isSearchWidget = true;
      } else {
        this.isSearchWidget = false;
      }

      this.editedData = response[0].result[0].BANNER_TEXT;
      this.editedData1 = response[0].result[0].BANNER_HEADER;
      this.logineditedData = response[0].result[0].LOGIN_BANNER_TEXT;
      this.bannerHeading = response[0].result[0].BANNER_HEADER;
      console.log(" this.bannerHeading=", this.bannerHeading);

      if (document.getElementById("tinymce") != null) {
        document.getElementById("tinymce").innerHTML =
          response[0].result[0].BANNER_TEXT;
      }

      this.screen_details = {
        BANNER_PAGE: response[0].result[0].BANNER_PAGE,
        PAGE_SECTION: response[0].result[0].PAGE_SECTION,
        // BANNER_CODE: response[0].result[0].BANNER_CODE,
        BANNER_IMAGE: response[0].result[0].BANNER_IMAGE,
        BANNER_TEXT: response[0].result[0].BANNER_TEXT,
        LOGIN_BANNER_IMAGE: response[0].result[0].LOGIN_BANNER_IMAGE,
        LOGIN_BANNER_TEXT: response[0].result[0].LOGIN_BANNER_TEXT,
        BANNER_TYPE: response[0].result[0].BANNER_CODE,
        BANNER_HEADING: response[0].result[0].BANNER_HEADER,
        PLATFORM: response[0].result[0].PLATFORM
        // APPLICABLE_FROM: selectedStartDate,
        // APPLICABLE_TO: selectedEndDate
        // IS_LOGIN: response[0].result[0].IS_LOGIN
      };
      console.log("BBBBBBBBBBBBBBBBBBBB----->", this.screen_details);
      this.previousData = this.screen_details;
      this.approveStatus = response[0].result[0].STATUS;
      var isLogin = response[0].result[0].IS_LOGIN;

      if (isLogin == "0") {
        this.checkGuest = true;
      } else {
        this.checkGuest = false;
      }
      if (isLogin == "1") {
        this.checkMember = true;
      } else {
        this.checkMember = false;
      }
      if (isLogin == "2") {
        this.checkBoth = true;
      } else {
        this.checkBoth = false;
      }
      this.serachTableInfo = response[0].result;

      if (toggle == "1") {
        this.showList = true;
        this.actionmode = "View";
      }
      if (toggle == "3") {
        this.showList = false;
        this.actionmode = "View";
      }
      if (toggle == "2") {
        if (this.isApproved && this.actionmode == "Edit") {
          this.checkColor();
        }
      }
    });
  }

  submitdata() {
    this.offSubmit = false;
    // var date1 = this.screen_details.APPLICABLE_FROM;
    // var selectedStartDate = new Date(date1).toISOString().split("T")[0];

    // var date2 = this.screen_details.APPLICABLE_TO;
    // var selectedEndDate = new Date(date2).toISOString().split("T")[0];

    var formData = [
      this.screen_details.BANNER_PAGE,
      this.screen_details.PAGE_SECTION,
      this.screen_details.BANNER_IMAGE,
      this.screen_details.BANNER_TEXT,
      this.screen_details.LOGIN_BANNER_IMAGE,
      this.screen_details.LOGIN_BANNER_TEXT,
      this.screen_details.BANNER_TYPE,
      this.screen_details.PLATFORM,
      this.screen_details.BANNER_HEADING
      // selectedStartDate,
      // selectedEndDate
    ];

    if (this.screen_details.BANNER_PAGE == "InnerPages") {
      this.screen_details.BANNER_IMAGE = "No Image";
    }
    if (
      this.screen_details.BANNER_PAGE == ""
      // this.screen_details.BANNER_CODE == "" ||
      // this.screen_details.BANNER_IMAGE == ""
      // this.screen_details.IS_LOGIN == null
    ) {
      document.getElementById("errs").innerHTML = "Please fill all record";
    } else {
      if (this.Parent_result_ID != "") {
        var array = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          parent_table_ID: this.parent_table_ID,
          formData: formData,
          formdataId: this.Parent_result_ID,
          USER_ID: this.uid
        };
        this.vernostService.editData(array).subscribe(response => {
          // alert(JSON.stringify(response[0].status));

          document.getElementById("errs").innerHTML =
            "Record updated successfully";
          setTimeout(() => {
            document.getElementById("errs").innerHTML = "";
            document.getElementById("errs").style.background = "#ebccd1";
            document.getElementById("errs").style.color = "#a94442";
          }, 1000);
          this.searchForm();
          this.logService.create_log_masters(
            "'Component Name':Banner Master,'Action':Update Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Privious Record':" +
              JSON.stringify(this.previousData) +
              ",'New Record':" +
              JSON.stringify(this.screen_details),
            "info"
          );
        });
      }
      if (this.Parent_result_ID == "") {
        var Data = {
          parent_table: this.parent_table,
          dbFields: this.dbFields,
          formData: formData,
          USER_ID: this.uid,
          PAGENAME: "BANNER"
        };

        //call webservice to save data into table

        this.vernostService.insertData(Data).subscribe(response => {
          if (JSON.stringify(response[0].message == "Data inserted")) {
            document.getElementById("errs").innerHTML =
              "Record Created Successfully";
            setTimeout(() => {
              document.getElementById("errs").innerHTML = "";
              document.getElementById("errs").style.background = "#ebccd1";
              document.getElementById("errs").style.color = "#a94442";
            }, 1000);

            this.showFormData(response[0].addinfo, 3, 1, 1);
            this.logService.create_log_masters(
              "'Component Name':Airport Master,'Action':Create Record,'Modified by':" +
                localStorage.getItem("fname") +
                ",'Record':" +
                JSON.stringify(this.screen_details),
              "info"
            );
          }
        });
      }
    }
  }

  searchData() {
    this.searchlist = false;
    this.loader = true;

    var field1 = this.search_details.BANNER_PAGE;
    var field2 = this.search_details.PAGE_SECTION;

    if (field1 == "" && field2 == "") {
      this.loader = false;
      document.getElementById("errs").innerHTML = "Please select some criteria";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (field1 != "") {
        searchitem.push(field1);
        searchColumn.push("BANNER_PAGE");
      }
      if (field2 != "") {
        searchitem.push(field2);
        searchColumn.push("PAGE_SECTION");
      }

      var Data = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: this.childtables,
        filters: this.filters
      };
      // alert(JSON.stringify(Data))
      this.vernostService.searchRecord(Data).subscribe(response => {
        if (response.length > 0) {
          this.loader = false;

          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = response;
          this.searchresult = true;
          this.logService.create_log_masters(
            "'Component Name':Banner Master,'Action':Srarch Record,'Modified by':" +
              localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "No Record Found..";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function () {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }

  checkTaxDescription(data) {
    this.validateTaxDescription(data);
  }
  validateTaxDescription(data) {
    if (data.length == 0) {
      this.bannerCodeMinLength = false;
    } else {
      if (data.length < 2) {
        this.bannerCodeMinLength = true;
        // this.bannerCodeNotAlphaNumeric = false;
      } else {
        this.bannerCodeMinLength = false;
      }
    }
  }
  checkTaxDescriptionLength(data) {
    this.bannerCodeExceedLength = false;
    this.bannerCodeMinLength = false;
    this.bannerCodeNotAlphaNumeric = false;

    if (this.actionmode == "Edit") {
      this.isApproved = false;
    }

    if (data.length == 0) {
      this.bannerCodeMinLength = false;
      this.bannerCodeNotAlphaNumeric = false;
    } else {
      // var regx = /^[^-\s][A-Za-z\s]+$/;
      var regx = /^[A-Za-z0-9\s]+$/;
      var checkAlphabet = regx.test(data);
      if (!checkAlphabet) {
        this.bannerCodeNotAlphaNumeric = true;
      } else {
        this.bannerCodeNotAlphaNumeric = false;
      }
    }

    if (data.length > 20) {
      this.bannerCodeExceedLength = true;
      this.bannerCodeMinLength = false;
    } else {
      this.bannerCodeExceedLength = false;
    }
  }

  submitData1() {
    ///  this.loader = true;
    if (this.actionmode != "Edit") {
      this.offSubmit = true;
      this.submitdata();
      // this.checkNames();
    } else {
      this.submitdata();
    }
    /* if (
      1 != 1
      // this.screen_details.BANNER_PAGE == ""
      // this.screen_details.PAGE_SECTION == ""
      // this.screen_details.BANNER_CODE == "" ||
      // this.screen_details.IS_LOGIN == null
    ) {
      document.getElementById("errs").innerHTML = "Please fill all record";
    } else {
      if (this.actionmode != "Edit") {
        this.offSubmit = true;
        this.submitdata();
        // this.checkNames();
      } else {
        this.submitdata();
      }
    } */
  }
  checkNames() {
    if (
      this.screen_details.PAGE_SECTION != "" &&
      this.screen_details.PAGE_SECTION != undefined
    ) {
      var array = {
        columnName: "PAGE_SECTION",
        dbFieldName: this.screen_details.PAGE_SECTION,
        parent_table: this.parent_table
      };

      this.vernostService.checkName(array).subscribe(data => {
        if (data[0].status == "Sucess") {
          this.nameExist = false;
          if (this.offSubmit) {
            this.submitdata();
          }
        } else {
          //  alert(data[0].message);
          this.nameExist = true;
        }
      });
    }
  }

  clearRemark() {
    this.minRemark = false;
    this.aprove_details.APPROVAL_REMARKS = "";
  }
  checkRemarkLength(data) {
    if (data.length < 3) {
      this.minRemark = true;
    } else {
      this.minRemark = false;
    }
  }

  getremark(val) {
    this.minRemark = false;
    if (val == undefined || val == "" || val.length < 3) {
      this.aprvbtn = false;
    } else {
      this.aprvbtn = true;
    }
  }
  keyupHandler(e) {
    this.screen_details.BANNER_TEXT = e;
  }
  keyupHandler1(e) {
    this.screen_details.BANNER_HEADING = e;
  }
  loginkeyupHandler(e) {
    this.screen_details.LOGIN_BANNER_TEXT = e;
  }
  url = window["omsubconfig"].fetchimageurl + "fetchimage?name=";
  

  getImage(val) {
    if (val == undefined) {
      return "../../assets/img/plain-white-background.jpg";
    } else {
      // return this.url + "1548941440487Cash_JPMiles.jpg";
      return this.url + val;
    }
  }
}
